<table class="table table-sm">
  <thead>
    <tr>
      <th>ID</th>
      <th>mac</th>
      <th>name</th>
      <th>flip</th>
      <th>manualStatus</th>
      <th>resetManualStatusAtNextSchedule</th>
      <th>manualStatusCreated</th>
      <th>turn off</th>
      <th>turn on</th>
    </tr>
  </thead>
  <tbody>
    @for (setting of settings; track setting.id) {
      <tr>
        <td>{{setting.id}}</td>
        <td>{{setting.mac}}</td>
        <td>{{setting.name}}</td>
        <td>{{setting.flip}}</td>
        <td>{{setting.manualStatus}}</td>
        <td>{{setting.resetManualStatusAtNextSchedule}}</td>
        <td>{{setting.manualStatusCreated}}</td>
        <td>
          <button class="btn btn-secondary" (click)="setValue(setting, false, false)">temp</button>
          <button class="btn btn-primary" (click)="setValue(setting, false, true)">perm</button>
        </td>
        <td>
          <button class="btn btn-secondary" (click)="setValue(setting, true, false)">temp</button>
          <button class="btn btn-primary" (click)="setValue(setting, true, true)">perm</button>
        </td>
      </tr>
    }
  </tbody>
</table>
